/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Status, ajax } from '../../twd'

export default ({name, maturity, ts:_ts, params}) => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [rows, setRows] = React.useState([])
    const [count, setCount] = React.useState(0)
    const [page, setPage] = React.useState(1)
    const [matTerm, setMatTerm] = React.useState(maturity || 'LT_3')
    const [ts, setTs] = React.useState(_ts || 0)

    React.useEffect(() => {
        setStatus(Status.LOADING)
        if (ts===0) return

        ;(async ()=> {
            try {

                let p = Object.assign({
                    searchType: 'offers',
                    pageNumber: page,
                    resultsPerPage: 10,
                    offeringType: ['ask-side'],
                    marketCheckRequired: true,
                    sort: [{
                        field: 'askYield',
                        direction: 'DESC'
                    }]
                }, params, getMatTermParams(matTerm))

                let {data} = await ajax({
                    url:'/esb/portfolio/offersearch',
                    method: 'POST',
                    params: p
                })

                let a = await data
                let filtered = 0
                a.rows = (rows || []).concat(a.rows)
                    .map(r => {
                        let { marketCheck } = r
                        if (marketCheck==='z' || marketCheck==='Z') {
                            filtered++
                            return null;
                        }
                        return r
                    })
                    .filter(Boolean)

                setRows(a.rows)
                setCount(a.resultSetCount - filtered)
                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

    }, [ts, name, page, matTerm])

    const reset = (matTerm) => {
        setRows([])
        setPage(1)
        setCount(0)
        setMatTerm(matTerm || 'LT_3')
        setTs(matTerm ? Date.now() : 0)
    }

    return { status, rows, count, page, setPage, setRows, setMatTerm, matTerm, reset, setTs }
}

const getMatTermParams = (term) => ({
    'LT_3': { holdMaturityMax: '3y' },
    '3_TO_5': { holdMaturityMin: '3y', holdMaturityMax: '5y' },
    '5_TO_10': { holdMaturityMin: '5y', holdMaturityMax: '10y' },
    '10_TO_20': { holdMaturityMin: '10y', holdMaturityMax: '20y' },
    'GT_20': { holdMaturityMin: '20y' },
}[term] || {})